import React from 'react';

import { HighlightedText } from '@lumapps/lumx-texts/components/HighlightedText';
import { Text } from '@lumapps/lumx/react';
import { useSelector } from '@lumapps/redux/react';
import { getSearchQuery } from '@lumapps/search/ducks/selectors';

export type SearchBoxOptionLabelProps = {
    label: string;
};

export const SearchBoxOptionLabel: React.FC<SearchBoxOptionLabelProps> = ({ label }) => {
    const searchQuery = useSelector(getSearchQuery);

    return (
        <Text as="span" truncate>
            <HighlightedText text={label} query={searchQuery} />
        </Text>
    );
};
